export const searchByParameterTypes = {
    KEYWORD: 'keyword',
    CATEGORY: 'category'
};

const FACET_DELIMITER = ',';
const FACET_VALUE_SEPERATOR = ':';

export default function searchByParameterManager(initialData) {
    const hasExpected = obj => {
        const expectedKeys = ['Facets', 'Query', 'Size', 'Sort', 'Start', 'Type'];
        const keys = Object.keys(obj);

        return keys.length === expectedKeys.length && keys.every(key => expectedKeys.includes(key));
    };

    if (!initialData || !hasExpected(initialData)) {
        throw new Error('searchByParameterManager expects data with required properties');
    }

    let _data = cloneDataObject(initialData);

    const type = () => _data.Type;

    const isCategory = () => type() === searchByParameterTypes.CATEGORY;

    const isKeyword = () => type() === searchByParameterTypes.KEYWORD;

    const toJSON = () => JSON.stringify(cloneDataObject(_data));

    const getPageNumber = () => Math.floor(_data.Start / _data.Size) + 1;

    const getKeyword = () => isKeyword() ? _data.Query : '';

    const getCategoryId = () => isCategory() ? _data.Query : '';

    const getFacetEntries = () => {
        return _data.Facets
            .filter(facet => Array.isArray(facet.Values) && facet.Values.length > 0)
            .map(({ Name, Values }) => {
                return [Name, Values];
            });
    };

    const setFacet = ({ name, value, isMultiSelect }) => {
        const val = value.trim();
        _data.Start = 0;

        if (!Array.isArray(_data.Facets)) {
            _data.Facets = [];
        }

        const facet = _data.Facets.find(facet => facet.Name === name);

        if (!facet) {
            _data.Facets.push({
                Name: name,
                Values: [val]
            });

            return;
        }

        if (!isMultiSelect) {
            facet.Values = [];
        }

        if (facet.Values.indexOf(val) === -1) {
            facet.Values.push(val);
        }
    };

    const setPageNumber = num => {
        _data.Start = _data.Size * (num - 1);
    };

    const setSize = num => {
        _data.Start = 0;
        _data.Size = num;
    };
    
    const setSort = num => {
        _data.Start = 0;
        _data.Sort = num;
    };

    const removeFacet = ({ name, value, isMultiSelect }) => {
        const facet = _data.Facets?.find(facet => facet.Name === name);
        const val = value.trim();

        _data.Start = 0;

        if (!facet) {
            return;
        }

        facet.Values = isMultiSelect
            ? removeItemFromArray(val, facet.Values)
            : [];

        if (!facet.Values.length) {
            _data.Facets = removeItemFromArray(facet, _data.Facets);
        }
    };

    const facetsToParameterString = () => {
        const facets = _data.Facets;

        if (!Array.isArray(facets) || !facets.length) {
            return '';
        }

        return facets.reduce((arr, item) => {
            if (!item.Name || !Array.isArray(item.Values)) {
                return arr;
            }

            return arr.concat(item.Values.map(value => encodeURIComponent(`${item.Name.trim()}${FACET_VALUE_SEPERATOR}${value.trim()}`)));
        }, []).join(FACET_DELIMITER);
    };

    const replaceFacetsFromParameterString = str => {
        if (!str || typeof str !== 'string') {
            return;
        }

        const facetMap = new Map();
        const encodedSeperator = encodeURIComponent(FACET_VALUE_SEPERATOR);

        str.split(FACET_DELIMITER)
            .forEach(item => {
                const [name, ...values] = item.split(encodedSeperator);
                const facetName = decodeURIComponent(name);

                if (!facetMap.has(facetName)) {
                    facetMap.set(facetName, []);
                }

                const facets = [...facetMap.get(facetName)];

                facets.push(decodeURIComponent(values.join(encodedSeperator)));

                facetMap.set(facetName, facets);
            });

        _data.Facets = [...facetMap.entries()].map(([name, values]) => {
            return {
                Name: name,
                Values: values
            };
        });
    };

    return {
        facetsToParameterString,
        getFacetEntries,
        getPageNumber,
        getKeyword,
        getCategoryId,
        isCategory,
        isKeyword,
        removeFacet,
        replaceFacetsFromParameterString,
        setFacet,
        setPageNumber,
        setSort,
        setSize,
        toJSON
    };
}

function cloneDataObject(value){
    if (typeof structuredClone === 'function') {
        return structuredClone(value);
    }

    return JSON.parse(JSON.stringify(value));
}

function removeItemFromArray(item, items) {
    var indexOf = items.indexOf(item);

    if (indexOf === -1) {
        return items;
    }

    return items.slice(0, indexOf).concat(items.slice(indexOf + 1, items.length));
}
